import { type UseMutationOptions, useMutation } from '@tanstack/react-query'
import {
	type HttpAddPhotosetCommentOptions,
	httpAddPhotosetComment
} from '@/features/photoset/http/photoset.http'
import { errorHandler } from '@/helpers/utils'

export const useAddPhotosetComment = (
	urlParams: HttpAddPhotosetCommentOptions['urlParams'],
	options?: UseMutationOptions<
		unknown,
		unknown,
		HttpAddPhotosetCommentOptions['payload']
	>
) => {
	return useMutation({
		...options,
		mutationFn: (payload) => httpAddPhotosetComment({ urlParams, payload }),
		onError: (error) => errorHandler(error),
		onSuccess: (data, variables, onMutateResult, context) => {
			options?.onSuccess?.(data, variables, onMutateResult, context)
		}
	})
}
